.toast {
	position: fixed;
	z-index: 20;
	bottom: 27px;
	left: 50%;
	max-width: min(420px, calc(100vw - 30px));
	padding: 10px 16px;
	border: 1px solid #dbd8e4;
	border-radius: 11px;
	color: #fff;
	background: #383349;
	box-shadow: 0 10px 28px rgba(43, 38, 63, 0.22);
	font-size: 15px;
	font-weight: 700;
	pointer-events: none;
	opacity: 0;
	transform: translate(-50%, 15px);
	transition:
		opacity 0.25s ease,
		transform 0.25s ease;
}

.toast[data-visible='true'] {
	opacity: 1;
	transform: translate(-50%, 0);
}

.toast[data-tone='good'] {
	background: #008e72;
}
.toast[data-tone='warn'] {
	background: #e04f67;
}
